import '../css/style.scss';

// Our modules / classes
import Register from './modules/Register';
// import OpenStreetMap from './modules/OpenStreet';
// import MyNotes from './modules/MyNotes';
import Header from './modules/Header';
import MyHelpers from './modules/MyHelpers';
import UpdateBilling from './modules/Update-Billing';
import LoginPage from './modules/LoginPage';

// Instantiate a new object using our modules/classes
// const register = new Register(['#vendor_services', '#another_select_list']);
const register = new Register(['#vendor_services']);
// const openStreetMap = new OpenStreetMap();
// const myNotes = new MyNotes();
const header = new Header();
const helpers = new MyHelpers();
const updateBilling = new UpdateBilling();
const loginPage = new LoginPage();
